/*
 * TPS — mobile: clamp long collection descriptions behind a Read more.
 *
 * On a 390px screen the Turnkey Sims intro runs eight lines, so a shopper sees no
 * product at all before scrolling. Clamping to three lines puts products on the first
 * screen while keeping the full copy in the DOM — it is still indexed, still readable,
 * just one tap away.
 *
 * Desktop is untouched: the description sits beside empty space there and costs nothing.
 *
 * The target is found by shape rather than by a generated class name, because the
 * collection heading section's block ids change whenever the section is edited in the
 * theme editor. Longest text block in the header section, over 180 characters.
 */

const MOBILE_MAX = 749;
const MIN_CHARS = 180;

function findDescription() {
  const main = document.querySelector('main');
  if (!main) return null;

  const header = main.querySelector('.shopify-section');
  if (!header) return null;

  const blocks = [...header.querySelectorAll('.text-block, rte-formatter')].filter((el) => {
    // Skip anything that is itself a wrapper around another candidate.
    if (el.querySelector('.text-block, rte-formatter')) return false;
    return (el.textContent || '').trim().length > MIN_CHARS;
  });

  if (!blocks.length) return null;
  return blocks.sort((a, b) => b.textContent.length - a.textContent.length)[0];
}

function teardown(el) {
  el.classList.remove('tps-clamp', 'tps-clamp--open');
  const btn = el.parentElement && el.parentElement.querySelector(':scope > .tps-clamp-toggle');
  if (btn) btn.remove();
}

function apply() {
  const el = findDescription();
  if (!el) return;

  if (window.innerWidth > MOBILE_MAX) {
    if (el.classList.contains('tps-clamp') || el.classList.contains('tps-clamp--open')) teardown(el);
    return;
  }

  if (el.dataset.tpsClamped === 'true') return;
  el.dataset.tpsClamped = 'true';
  el.classList.add('tps-clamp');

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'tps-clamp-toggle';
  btn.textContent = 'Read more';
  btn.setAttribute('aria-expanded', 'false');

  btn.addEventListener('click', () => {
    const open = el.classList.toggle('tps-clamp--open');
    el.classList.toggle('tps-clamp', !open);
    btn.textContent = open ? 'Read less' : 'Read more';
    btn.setAttribute('aria-expanded', String(open));
  });

  el.insertAdjacentElement('afterend', btn);
}

function start() {
  apply();
  let t;
  window.addEventListener('resize', () => {
    clearTimeout(t);
    t = setTimeout(apply, 200);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
